import * as React from "react";

import { AdCopyResultTableRow } from "../../../../simulation/result/result-table/ad-copy-result-table-row";
import { SellPotentialValue } from "../../../../../../report/simulation/result/result-table";
import { isDefined } from "../../../../../../../../lib/data";

// 推定値テーブル

type Props = {
	hasCurrentProduct: boolean;
	sellPotentials: SellPotentialValue[];
	goalSalesVolume: number;
};

export const AdCopyResultTable = React.memo((props: Props) => {
	const { hasCurrentProduct, sellPotentials, goalSalesVolume } = props;

	const initValues = React.useMemo(() => sellPotentials[0].sellPotential, [sellPotentials]);
	const cpValues = React.useMemo(() => sellPotentials[1].sellPotential, [sellPotentials]);
	const testValues = React.useMemo(() => sellPotentials[2].sellPotential, [sellPotentials]);

	return (
		<table className="result-table">
			<thead>
				<tr>
					<th className="subtitle" rowSpan={2}>
						推定値
					</th>

					<th rowSpan={2}>初期値(万個)</th>

					<th colSpan={2}>①実績値 修正後</th>

					<th colSpan={2}>②テスト品 変数補整後</th>
				</tr>

				<tr>
					<th>補整値(万個)</th>

					<th>補整率(%)</th>

					<th>補整値(万個)</th>

					<th>補整率(%)</th>
				</tr>
			</thead>

			<tbody>
				<AdCopyResultTableRow
					cpValue={cpValues.trial}
					hasCurrentProduct={hasCurrentProduct}
					initialValue={initValues.trial}
					label="トライアル"
					name="trial"
					testValue={testValues.trial}
				/>

				<AdCopyResultTableRow
					cpValue={cpValues.repeat}
					hasCurrentProduct={hasCurrentProduct}
					initialValue={initValues.repeat}
					label="リピート"
					name="repeat"
					testValue={testValues.repeat}
				/>

				<AdCopyResultTableRow
					cpValue={cpValues.localOther}
					hasCurrentProduct={hasCurrentProduct}
					initialValue={initValues.localOther}
					label="ローカルその他"
					name="localOther"
					testValue={testValues.localOther}
				/>

				<AdCopyResultTableRow
					cpValue={cpValues.inbound}
					hasCurrentProduct={hasCurrentProduct}
					initialValue={initValues.inbound}
					label="インバウンド"
					name="inbound"
					testValue={testValues.inbound}
				/>

				<AdCopyResultTableRow
					cpValue={cpValues.total}
					hasCurrentProduct={hasCurrentProduct}
					initialValue={initValues.total}
					label="合計"
					name="total"
					testValue={testValues.total}
				/>

				{/* NOTE: コンセプトテストのやり方。コピーテストでは、目標対比もserver側の関数を使用して算出することとする */}
				{/* <AdCopyResultTableRow
					correctionValue={
						correctionValues?.total == null ? undefined : (correctionValues.total / goalSalesVolume) * 100 - 100
					}
					initValue={(initValues.total / goalSalesVolume) * 100 - 100}
					label="目標対比(%)"
					name="goal"
					targetValue={targetValues?.total == null ? undefined : (targetValues.total / goalSalesVolume) * 100 - 100}
				/> */}

				<AdCopyResultTableRow
					hasCurrentProduct={hasCurrentProduct}
					initialValue={(initValues.total / goalSalesVolume) * 100 - 100}
					label="目標対比(%)"
					name="goal"
					testValue={isDefined(testValues.total) ? (testValues.total / goalSalesVolume) * 100 - 100 : undefined}
					cpValue={isDefined(cpValues.total) ? (cpValues.total / goalSalesVolume) * 100 - 100 : undefined}
				/>
			</tbody>
		</table>
	);
});
